import { useQuery } from "react-query";
import { getData } from "../newApis/apiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { IResponse } from "../interfaces/response";

const getAuditTrailEntityTypes = async (): Promise<IResponse<string[]>> => {
  const data = await getData(ajaxEndpoints.PRODUCT_AUDITS_ENTITY_TYPE);
  return data;
};

export default function useAuditTrailEntityTypes() {
  return useQuery<IResponse<string[]>>(
    ["getAuditTrailEntityTypes"],
    getAuditTrailEntityTypes
  );
}
